<template>
  <Box
    :style="{
      '--bg-color': colors[campaignFromNumber(shirt.campaignId)],
    }"
    rounded="md"
    border="md"
    :class="`flex h-10 w-10 flex-col items-center rounded-full bg-[--bg-color] p-1 transition-colors`"
  >
    <NuxtImg :src="src" class="h-full object-contain" />
  </Box>
</template>

<script setup lang="ts">
import { useNfcShirtIcon } from "~/domains/nfc/composables";
import type { NFCType } from "~/domains/nfc/types";
import { campaignFromNumber, colors } from "~/lib/campaigns";

const props = defineProps<{
  shirt: {
    campaignId: number;
    type: NFCType;
  };
}>();

const src = useNfcShirtIcon(() => props.shirt.type);
</script>
